import { useState, useEffect } from 'react';
import { loadGallery } from './galleryCache';

function AvailableWork() {
  const [works, setWorks] = useState([]);

  useEffect(() => {
    let cancelled = false;
    loadGallery('Works For Sale').then((records) => {
      if (cancelled) return;
      setWorks(records);
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="available-work" className="min-h-screen pt-20 md:pt-32 px-4 md:px-0 md:ml-[25%] md:pr-8 pb-24 md:pb-8 bg-white">
      <div className="flex flex-col gap-16 md:gap-24">
        {works
          .filter((record) => {
            const { Attachments, Display } = record.fields;
            return Attachments?.[0] && Display;
          })
          .map((record, index) => {
            const { Attachments, Title, Year, Medium, Dimensions, Price } = record.fields;
            const image = Attachments[0];
            const thumb = image.thumbnails?.large ?? image;

            return (
              <div key={record.id} className="md:grid md:grid-cols-3 md:gap-8 flex flex-col gap-4">
                <div className="hidden md:block" />
                <div>
                  <img
                    src={thumb.url}
                    width={image.width}
                    height={image.height}
                    style={{ aspectRatio: `${image.width} / ${image.height}` }}
                    loading={index < 10 ? 'eager' : 'lazy'}
                    decoding="async"
                    alt={Title || 'Available work'}
                    className="w-full block"
                  />
                </div>
                <div className="flex flex-col justify-end text-base md:text-lg">
                  {Title && <span className="italic">{Title}</span>}
                  {Year && <span>{Year}</span>}
                  {Medium && <span>{Medium}</span>}
                  {Dimensions && <span>{Dimensions}</span>}
                  {Price && <span>${Price}</span>}
                </div>
              </div>
            );
          })}
      </div>
      <div className="fixed bottom-0 right-0 z-[60] py-4 md:py-8 px-4 md:px-8 text-l md:text-l">
        Inquire for work:{' '}
        <a href="mailto:mvodyanyk@gmail.com" className="hover:text-gray-500">
          mvodyanyk@gmail.com
        </a>
      </div>
    </section>
  );
}

export default AvailableWork;
